import React from 'react';
import { IconAuditorNotes } from 'jitsi/base/icons/svg';
import NotesComponent from '../../../features/meeting-auditor/NotesComponent'
import { useDispatch,useSelector } from 'react-redux';

const AuditorNotesButton = () => {
    const dispatch = useDispatch();
    const showAuditorNotes = useSelector((state) => state['features/meeting-auditor'].isMessageListOpen);
    return  <>
                <div style={{ position: 'fixed', top: '30px', left: '30px', height: '40px', width: '40px', cursor: 'pointer'}}>
                    <IconAuditorNotes
                        onClick={() => dispatch({type: 'SHOW_AUDIT_MESSAGE_LIST',isMessageListOpen: true})} />
                </div>
                { showAuditorNotes && <NotesComponent />}
            </>
}
export default AuditorNotesButton